<template>
  <div class="text-center mb-5" v-if="loading">
    <b-spinner variant="danger" style="width: 3rem; height: 3rem;" />
  </div>
  <div v-else class="feed-search-resources text-light">
    <div v-if="lives.length" class="px-4 px-lg-5">
      <h5>Lives</h5>
    </div>
    <action-dispatcher
      class="position-relative mb-5"
      action="search/searchLives"
      :parameters="term"
    >
      <div class="px-4 px-lg-5">
        <swiper :navigation="true" :breakpoints="lBreakpoints">
          <swiper-slide v-for="live in lives" :key="live.id">
            <live-slide :live="live" />
          </swiper-slide>
        </swiper>
      </div>
    </action-dispatcher>

    <div v-if="audios.length" class="px-4 px-lg-5">
      <h5>Áudios</h5>
    </div>
    <action-dispatcher
      class="position-relative mb-5"
      action="search/searchAudios"
      :parameters="term"
    >
      <div class="px-4 px-lg-5">
        <swiper :navigation="true" :breakpoints="aBreakpoints">
          <swiper-slide v-for="audio in audios" :key="audio.id">
            <audio-slide :resource="audio" />
          </swiper-slide>
        </swiper>
      </div>
    </action-dispatcher>

    <div class="px-4 px-lg-5">
      <h5>Aulas</h5>
    </div>
  </div>
</template>

<script>
import Swiper from "@/components/Swiper";
import SwiperSlide from "@/components/SwiperSlide";
import AudioSlide from "@/components/trail/AudioSlide";
import LiveSlide from "@/components/lives/LiveSlide";
import { mapState } from "vuex";

let timeout = null;

export default {
  components: {
    AudioSlide,
    LiveSlide,
    Swiper,
    SwiperSlide
  },
  props: {
    text: String
  },
  data() {
    return {
      term: this.text,
      loading: false,
      lBreakpoints: {
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        },
        1600: {
          slidesPerView: 5
        }
      },
      aBreakpoints: {
        992: {
          slidesPerView: 2
        },
        1200: {
          slidesPerView: 3
        },
        1600: {
          slidesPerView: 4
        }
      }
    };
  },
  computed: {
    ...mapState("search", ["lives", "audios"])
  },
  watch: {
    text() {
      this.loading = true;
      timeout = setTimeout(() => {
        this.loading = false;
        this.term = this.text;
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.feed-search-resources {
  h5 {
    margin-bottom: 16px;
    font-size: 18px;
  }
}
</style>
